module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Hard-drive-922b640fde97e0c81337c0bb5e9b579e.svg";